export enum JOB_APPLICATION_TAB {
  PROFILE = 'profile',
  EMAILS = 'emails',
  RESUME = 'resume',
  COVER_LETTER = 'cover-letter',
  SELECTION_CRITERIA = 'selection-criteria',
  PREVIOUS_APPLICATIONS = 'previous-applications',
  NOTES_ATTACHMENTS = 'notes-attachments',
  VERIFICATIONS = 'verifications',
}
